<template>
  <status-badge :color="displayStatus.color">{{ displayStatus.text }}</status-badge>
</template>
<script>
  import StatusBadge from '@/components/StatusBadge';
  import {LocaleUtils} from '@/utils/locale-utils';
  export default {
    name: 'ComputedStatusBadge',
    mixins: [
        LocaleUtils
    ],
    components: {StatusBadge},
    props: {
      statusList: {
        type: Array,
        required: true
      },
      value: {
        required: true
      }
    },
    computed: {
      convertedValue() {
        if(this.value != null && typeof this.value === 'object') {
          return this.value.value;
        }
        return this.value;
      },
      displayStatus() {
        let foundValue = this.statusList.find(status => status.value === this.convertedValue);

        if(foundValue == null) {
          foundValue = {
            text: this.trans('general.unknown'),
            color: 'gray'
          }
        }

        return foundValue;
      }
    }
  }
</script>
